(function () {
function isExternalLink(a) {
    if (!a || !a.href) return false;

    const hrefAttr = (a.getAttribute('href') || '').trim();

    // Ignore anchors, javascript:, mailto:, tel:
    if (
    hrefAttr.startsWith('#') ||
    hrefAttr.startsWith('javascript:') ||
    hrefAttr.startsWith('mailto:') ||
    hrefAttr.startsWith('tel:')
    ) return false;

    // Respect explicit opt-out
    if (a.dataset && a.dataset.sameTab === 'true') return false;

    // Respect existing target
    if (a.getAttribute('target')) return false;

    // Build an absolute URL safely
    let url;
    try { url = new URL(a.href, window.location.href); }
    catch (e) { return false; }

    // Same origin = internal
    if (url.origin === window.location.origin) return false;

    // Treat myshopify as internal (optional)
    if (url.hostname.endsWith('myshopify.com')) return false;

    // --- EXCLUSIONS: open these external domains in SAME tab ---
    const allowSameTabDomains = ['facebook.com', 'instagram.com'];
    if (allowSameTabDomains.some(d => url.hostname === d || url.hostname.endsWith('.' + d))) {
    return false;
    }
    // -----------------------------------------------------------

    return true;
}

function apply(root) {
    const links = (root || document).querySelectorAll('a[href]');
    links.forEach(function (a) {
    if (!isExternalLink(a)) return;

    a.setAttribute('target', '_blank');

    // Security best practice
    const rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (!rel.includes('noopener')) rel.push('noopener');
    if (!rel.includes('noreferrer')) rel.push('noreferrer');
    a.setAttribute('rel', rel.join(' '));
    });
}

// Prevent hash placeholders ("#" / "#!") from adding "#" to the URL
document.addEventListener('click', function (e) {
    const a = e.target.closest('a[href]');
    if (!a) return;

    const href = (a.getAttribute('href') || '').trim();
    if (href === '#' || href === '#!') {
    e.preventDefault();
    }
}, true);

// Initial pass
apply(document);

// Handle dynamically injected links (apps, ajax sections, etc.)
const obs = new MutationObserver(function (mutations) {
    for (const m of mutations) {
    for (const node of m.addedNodes) {
        if (node && node.nodeType === 1) apply(node);
    }
    }
});
obs.observe(document.documentElement, { childList: true, subtree: true });
})();